// PROPOSITO: la preferencia de tema de la persona: leerla, guardarla y aplicarla al documento.
// DEPENDENCIAS: ninguna. Solo el DOM y el almacenamiento del dispositivo.
// NO OBVIO (1): "sistema" QUITA el atributo. No lo pone en claro ni en oscuro: lo quita, para que
// mande la regla @media (prefers-color-scheme) que ya genera build-tokens.mjs. Si lo fijaramos,
// dejaria de seguir al telefono cuando el telefono cambia solo al anochecer.
// NO OBVIO (2): la clave CLAVE_TEMA esta repetida a proposito en el script en linea de index.html,
// que corre antes del primer pintado para que no haya parpadeo. El guard check-tema.mjs vigila que
// las dos digan lo mismo: si se separan, vuelve el destello de tema equivocado.
// NO OBVIO (3): leer o escribir el almacenamiento LANZA en modo privado de algunos navegadores.
// Por eso todo va envuelto: quedarse sin preferencia guardada es aceptable; caerse no.

export const TEMAS = ['sistema', 'claro', 'oscuro'] as const
export type Tema = (typeof TEMAS)[number]

export const CLAVE_TEMA = 'florfit-tema'
export const TEMA_POR_DEFECTO: Tema = 'sistema'

function esTema(valor: string | null): valor is Tema {
  return valor !== null && (TEMAS as readonly string[]).includes(valor)
}

/** Lo que la persona eligio la ultima vez en este dispositivo. */
export function leerTemaGuardado(): Tema {
  try {
    const guardado = window.localStorage.getItem(CLAVE_TEMA)
    return esTema(guardado) ? guardado : TEMA_POR_DEFECTO
  } catch {
    return TEMA_POR_DEFECTO
  }
}

/** Pinta el documento con el tema pedido. No guarda nada. */
export function pintarTema(tema: Tema): void {
  const raiz = document.documentElement
  if (tema === 'sistema') raiz.removeAttribute('data-tema')
  else raiz.setAttribute('data-tema', tema)
}

/** Pinta y recuerda. Es lo que llama el selector. */
export function aplicarTema(tema: Tema): void {
  pintarTema(tema)
  try {
    window.localStorage.setItem(CLAVE_TEMA, tema)
  } catch {
    // Sin almacenamiento: el tema vale para esta sesion y se olvida. No es motivo de error visible.
  }
}
